import { ScreenInsightsBuilding } from '@dms/screen'

// export { getServerSideProps } from '@dms/screen/insights'

export default ScreenInsightsBuilding
